<template>
  <div class="">
    <div class="top-search-box">
      <topTab :rout="rout"></topTab>
    </div>
    <div class="content">
    <div class="b-box">
      <div class="box">
        <div class="title">{{ data.title }}</div>
        <div class="line">
          <img src="../../../../assets/home/line.png" />
        </div>
        <div class="yi">寓意是</div>
        <!-- <div class="text">梦见死人或死亡不用害怕，不一定是坏事。</div> -->
        <div class="text" v-html="data.content"></div>
        <!-- <div class="text">
          一方面，梦见不知名的死人或者尸体，往往代表已经死亡、死去、结束、消亡的事物,预示你会进入新阶段，迎接新的开始。如果死去的是美好的人或事，那预示痛苦的失去;如果死者相貌丑陋，则代表坏的事物的消失。梦见一具熟人的尸体，意味着梦者恋爱中的失意与不幸;
        </div>
        <div class="text">梦见自己死亡，暗示</div> -->
      </div>
    </div>
    <div class="goback" @click="$router.back()">返回</div>
    </div>
  </div>
</template>

<script>
/**
@description:解梦详情
@createTime:2021-08-26
@create:wq
*/
import topTab from "@/components/topTab";
export default {
  name: "",
  props: {},
  components: {topTab},
  data() {
    return {
      data: "",
       rout:[{
        name:'首页',
        path:'/home'
      },{
        name:'周公解梦',
        path:'/zgjm'
      },{
        name:'周公解梦',
      }]
    };
  },
  computed: {},
  watch: {},
  mounted() {},
  created() {
    const data = localStorage.getItem("result");
    if (data) this.data = JSON.parse(data);
  },
  destroyed() {
    localStorage.removeItem("result");
  },
  methods: {},
};
</script>
<style lang="scss" scoped>
.b-box {
  padding: 0.12rem;
  border-radius: 0.4rem;
  box-shadow: 0 3px 6px rgba($color: #000000, $alpha: 0.16);
  margin: 0.24rem;
}
.box {
  padding: 0.52rem;
  border-radius: 0.28rem;
  border: 1px solid #53cedc;
  .title {
    font-size: 0.4rem;
    font-weight: 400;
    color: #53cedc;
    text-align: center;
  }
  .line {
    width: 2.74rem;
    margin: 0.06rem auto;
    img {
      width: 100%;
    }
  }
  .yi {
    font-size: 0.28rem;
    font-weight: bold;
    color: #707070;
    text-align: center;
  }
  .text {
    font-size: 0.28rem;
    font-weight: 400;
    color: #707070;
    border-bottom: 1px solid #e8c9a2;
    padding: 0.2rem 0;
    &:last-child {
      border-bottom: none;
    }
  }
}
.goback {
  width: 2.78rem;
  height: 0.88rem;
  border-radius: 0.54rem;
  margin: 0 auto;
  background: #f9647d;
  font-size: 0.3rem;
  font-weight: 400;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
</style>
